module.exports = {
      id: "comm-vikatan-plus-usage",
      viewBox: "0 0 484.569 52.881",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-vikatan-plus",
      toString: function () {
        return this.url;
      }
    }